import React, { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { DataToolbar, StatusBadge } from "@/components/data/Common";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Projects() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", client: "", location: "", capacity_tpd: 0, opening_feedstock_stock: 0 });

  const load = () => api.get("/projects").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try { await api.post("/projects", form); toast.success("Project created"); setOpen(false); setForm({ name: "", client: "", location: "", capacity_tpd: 0, opening_feedstock_stock: 0 }); load(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  const filtered = list.filter((p) => !q || `${p.name} ${p.client} ${p.location}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <AppLayout title="Projects" subtitle="All plant sites under management">
      <DataToolbar
        search={q} setSearch={setQ}
        onAdd={() => setOpen(true)} addLabel="New Project"
        addTestId="project-add-button" searchTestId="project-search-input"
      />
      <Card className="overflow-hidden" data-testid="projects-table-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Project</TableHead><TableHead>Client</TableHead><TableHead>Location</TableHead>
              <TableHead className="text-right">Capacity (TPD)</TableHead><TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((p) => (
              <TableRow key={p.id} data-testid={`project-row-${p.id}`}>
                <TableCell className="font-medium">{p.name}</TableCell>
                <TableCell>{p.client}</TableCell>
                <TableCell className="text-slate-500">{p.location}</TableCell>
                <TableCell className="text-right font-mono">{p.capacity_tpd}</TableCell>
                <TableCell><StatusBadge status={p.status} /></TableCell>
              </TableRow>
            ))}
            {!filtered.length && <TableRow><TableCell colSpan={5} className="text-center py-12 text-slate-400">No projects</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="project-create-dialog">
          <DialogHeader><DialogTitle>New Project</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="label-cap">Name</Label><Input data-testid="project-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div><Label className="label-cap">Client</Label><Input data-testid="project-client-input" value={form.client} onChange={(e) => setForm({ ...form, client: e.target.value })} /></div>
            <div><Label className="label-cap">Location</Label><Input data-testid="project-location-input" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} /></div>
            <div><Label className="label-cap">Capacity (TPD)</Label><Input type="number" data-testid="project-capacity-input" value={form.capacity_tpd} onChange={(e) => setForm({ ...form, capacity_tpd: parseFloat(e.target.value) || 0 })} /></div>
            <div><Label className="label-cap">Opening Feedstock Stock (MT)</Label><Input type="number" data-testid="project-opening-stock-input" value={form.opening_feedstock_stock} onChange={(e) => setForm({ ...form, opening_feedstock_stock: parseFloat(e.target.value) || 0 })} /></div>
          </div>
          <DialogFooter><Button onClick={submit} data-testid="project-create-submit" className="bg-sky-900 hover:bg-sky-950">Create</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </AppLayout>
  );
}
